export default __webpack_public_path__ + "static/10_21-133637f5868d2507e97201331fa1b061.png";